import type { DateRange } from '../types/extranet-api.types';

/**
 * Convertit le filterStore (ISO 8601 complet) au format attendu par l'API
 * (YYYY-MM-DD, cf. SPEC §3 conventions).
 */
export const toApiDateRange = (range: DateRange): { from: string; to: string } => ({
  from: range.from.slice(0, 10),
  to: range.to.slice(0, 10),
});
